import React, {
  useRef,
  useImperativeHandle,
  forwardRef,
  useState,
} from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatDate } from '@roc/feature-utils';

const useStyles = makeStyles(theme => ({
  canvas: {
    width: '100%',
    height: 200,
    background: '#f7f7f7',
    border: '1px solid #aaa',
    borderRadius: 16,
  },
}));

export type SignatureFieldHandle = {
  getSignature: () => string | null;
  clear: () => void;
  scrollTo: () => void;
  isSigned: () => boolean;
};

type SignatureFieldProps = {
  penColor?: string;
};

export const SignatureField = forwardRef<
  SignatureFieldHandle,
  SignatureFieldProps
>(({ penColor = 'black' }, ref) => {
  const classes = useStyles();
  const canvasRef = useRef<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isSigned, setIsSigned] = useState(false);

  useImperativeHandle(ref, () => ({
    getSignature: () =>
      isSigned
        ? canvasRef.current.getTrimmedCanvas().toDataURL('image/png')
        : null,
    clear: () => {
      canvasRef.current.clear();
      setIsSigned(false);
    },
    scrollTo: () => {
      containerRef.current?.scrollIntoView({ behavior: 'smooth' });
    },
    isSigned: () => {
      return isSigned
    }
  }));

  return (
    <div ref={containerRef}>
      <Box>
        <SignatureCanvas
          penColor={penColor}
          ref={canvasRef}
          canvasProps={{ className: classes.canvas }}
          onEnd={() => setIsSigned(true)}
        />
        <Box display="flex" justifyContent="space-between" mt={1}>
          <Button
            size="small"
            onClick={() => {
              canvasRef.current.clear();
              setIsSigned(false);
            }}
          >
            Clear
          </Button>
          <Typography variant="body2" color="textSecondary">
            {formatDate(new Date())}
          </Typography>
        </Box>
      </Box>
    </div>
  );
});
